import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowUpRight,
  FiAward,
  FiClock,
  FiMapPin,
  FiShield,
} from "react-icons/fi";
import {
  FaqSection,
  HomeLongFormSections,
  TestimonialsSection,
} from "../Components/LongFormContent";
import { ClientSlider, HomeSlider } from "../Components/HomeSlider";
import { homeOnPageContent } from "../data/onPageContent";

const Home = () => {
  return (
    <div>
      <HomeSlider />

      <main>
        <section className="recon-brand-hero px-4 py-16 text-white md:py-20 lg:py-24">
          <div className="relative mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1.35fr_0.65fr] lg:gap-16">
            <div>
              <div className="recon-kicker recon-kicker--dark">
                <FiShield aria-hidden="true" />
                ISO/IEC 17025:2017 accredited
              </div>
              <h1 className="mt-6 max-w-4xl text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl md:text-5xl">
                {homeOnPageContent.title}
              </h1>
              <h2 className="mt-6 max-w-3xl text-lg font-semibold leading-8 text-[#65d3df] md:text-2xl">
                {homeOnPageContent.subtitle}
              </h2>

              <div className="mt-7 max-w-3xl space-y-4 text-base leading-8 text-slate-200">
              {homeOnPageContent.intro.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              </div>

              <div className="home-hero-actions mt-9">
                <Link
                  to="/contact"
                  className="home-hero-button home-hero-button--primary"
                >
                  Request Calibration Support
                  <FiArrowUpRight aria-hidden="true" />
                </Link>
                <Link
                  to="/services"
                  className="home-hero-button home-hero-button--secondary"
                >
                  Explore Our Services
                  <FiArrowUpRight aria-hidden="true" />
                </Link>
              </div>
            </div>

            <aside className="recon-glass-panel p-6 sm:p-7">
              <div className="flex items-center gap-4 border-b border-white/10 pb-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#65d3df]/15 text-2xl text-[#65d3df]">
                  <FiAward aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#65d3df]">
                    NABL Certificate
                  </p>
                  <p className="mt-1 font-bold text-white">
                    NABLC0626MH04748
                  </p>
                </div>
              </div>
              <ul className="mt-2 divide-y divide-white/10">
                <li className="flex items-center gap-4 py-5">
                  <FiMapPin className="text-xl text-[#65d3df]" aria-hidden="true" />
                  <div>
                    <p className="font-bold text-white">Pune & PAN India</p>
                    <p className="mt-1 text-sm text-slate-300">
                      Laboratory and eligible on-site support
                    </p>
                  </div>
                </li>
                <li className="flex items-center gap-4 py-5">
                  <FiClock className="text-xl text-[#65d3df]" aria-hidden="true" />
                  <div>
                    <p className="font-bold text-white">Responsive Turnaround</p>
                    <p className="mt-1 text-sm text-slate-300">
                      Planned service with complete traceability
                    </p>
                  </div>
                </li>
              </ul>
              <Link
                to="/certificates"
                className="mt-1 inline-flex items-center gap-2 text-sm font-bold text-[#65d3df] transition hover:text-white"
              >
                View accreditation details
                <FiArrowUpRight aria-hidden="true" />
              </Link>
            </aside>
          </div>
        </section>

        <HomeLongFormSections sections={homeOnPageContent.sections} />
        <FaqSection faqs={homeOnPageContent.faqs} />
        <TestimonialsSection testimonials={homeOnPageContent.testimonials} />
        <ClientSlider />
      </main>
    </div>
  );
};

export default Home;
